import { render, staticRenderFns } from "./loadtask.vue?vue&type=template&id=7a234a20&scoped=true"
import script from "./loadtask.vue?vue&type=script&lang=js"
export * from "./loadtask.vue?vue&type=script&lang=js"
import style0 from "./loadtask.vue?vue&type=style&index=0&id=7a234a20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a234a20",
  null
  
)

export default component.exports